import { render, staticRenderFns } from "./Bound.vue?vue&type=template&id=0bcb0a07&"
import script from "./Bound.vue?vue&type=script&lang=js&"
export * from "./Bound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports